import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { InvDiv } from "../Style";
import Output from "./Output";
import Names from "./Names";
import Links from "./Links";
import Footer from "./Footer";
import Extra from "./Extra";
import GenericArivalConfirmation from "./GenericArivalConfirmation";
import { handleClickScroll } from "../others/Functions";
//
const InvitationDemo = ({
  cropAreaAspect,
  picPosition,
  topColor,
  bottomColor,
  heartColor,
}) => {
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 2000);
  }, []);

  const borderedInvsStyle = {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.7)",
    boxShadow: "0 1px 2px silver",
    padding: "5px",
    boxShadow: "0 2px 4px silver",
    borderRadius: "3px",
    paddingBottom: "20px",
  };
  const basicDivStyle =
    user?.invK === 1 ? { width: "100%" } : borderedInvsStyle;

  return (
    <InvDiv
      gradient={[topColor, bottomColor]}
      style={{
        width: "100%",
        border: "5px solid #3a3c3f",
        borderRadius: "15px",
        height: `${window.screen.availHeight}px`,
        maxHeight: "720px",
        maxWidth: "380px",
        padding: user.invK === 1 ? "0" : "15px",
        margin: "20px auto",
        position: "relative",
      }}
    >
      <div style={{ ...basicDivStyle }}>
        <Output
          _id={user._id}
          pic={user.pic}
          picPosition={picPosition}
          cropAreaAspect={cropAreaAspect}
        />
        {user.inv === 1 && <Names data={user} heartColor={heartColor} />}
        <GenericArivalConfirmation
          isDemo={true}
          heartColor={heartColor}
          acceptLimit={user.acceptLimit}
          specialDishes={user.specialDishes}
          separation={user.separation}
          seuda={user.seuda}
          transportation={user.transportation}
          specialMsg={user.specialMsg}
          specialMsgDetails={user.specialMsgDetails}
          blessing={user.blessing}
          blessTitle={user.blessTitle}
          transportationDetails={user.transportationDetails}
          invK={user.invK}
        />
        <Links data={user} />
        {user.inv === 1 && <Extra data={user} />}
        {/* לעשות כמו בי סימפל */}
      </div>
      <div style={{ height: "200px" }} />
      <Footer producer={user.producer} />
    </InvDiv>
  );
};

export default InvitationDemo;
